// /src/components/imovel/cadastro/5EtapaResumoFinal.jsx
// VERSÃO FINAL SUPREMA - SIMULADOR DE COMBATE & PREVIEW (TIM UNITY)

import React, { useMemo } from 'react';
import { 
    FiShield, FiActivity, FiGlobe, FiSearch, FiZap, 
    FiCheckCircle, FiAward, FiRefreshCw, FiUser, FiSmartphone 
} from 'react-icons/fi';

export default function EtapaResumoFinal({ formData }) {
    
    // 🤖 INTELIGÊNCIA DE SEO: Fallbacks Dinâmicos
    const displaySeoTitle = useMemo(() => {
        return formData.seoTitulo || `${formData.tipoNegocio || 'Plano'} ${formData.titulo || 'TIM Empresas'}`;
    }, [formData.seoTitulo, formData.tipoNegocio, formData.titulo]);

    const displaySeoDesc = useMemo(() => {
        return formData.seoDescricao || `Conheça o plano ${formData.titulo || 'TIM'}, ideal para seu negócio. Benefícios exclusivos, ligações ilimitadas e apps inclusos. Contrate agora!`;
    }, [formData.seoDescricao, formData.titulo]);

    return (
        <div className="w-full space-y-12 animate-in fade-in zoom-in-95 duration-700 pb-20">
            
            {/* 🛰️ HEADER DE ETAPA (STEP 05) */}
            <div className="flex items-center gap-6 mb-12 border-b border-white/5 pb-8">
                <div className="relative">
                    <div className="w-16 h-16 rounded-3xl bg-accent/10 border border-accent/20 flex items-center justify-center text-accent shadow-2xl">
                        <FiCheckCircle size={32} />
                    </div>
                    <div className="absolute -top-2 -right-2 w-7 h-7 bg-accent text-black rounded-full flex items-center justify-center font-black text-[12px] border-2 border-[#000022] shadow-lg">
                        05
                    </div>
                </div>
                <div>
                    <h2 className="text-3xl font-black uppercase tracking-tighter leading-none">
                        Simulador de <span className="text-accent">Combate</span>
                    </h2>
                    <p className="text-[10px] font-black uppercase tracking-[0.4em] opacity-40 mt-2">
                        Validação Final de Vitrine e Radar de Indexação
                    </p>
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
                
                {/* 🚀 LADO ESQUERDO: PREVIEW DO CARD (COMO FICA NA VITRINE) */}
                <div className="lg:col-span-5 space-y-6">
                    <Label icon={FiZap} text="Preview Tático do Card" accent />
                    
                    <div className={`relative group w-full max-w-[380px] mx-auto overflow-hidden rounded-[32px] border transition-all duration-500 bg-[#050505] ${formData.isVIP === 'Sim' ? 'border-[#EB0404] shadow-[0_0_30px_rgba(235,4,4,0.15)]' : 'border-white/10'}`}>
                        {/* Selo Destaque */}
                        {formData.seloDestaque && (
                            <div className="absolute top-4 left-4 z-20 bg-accent text-black text-[8px] font-black uppercase px-3 py-1 rounded-full shadow-lg">
                                {formData.seloDestaque}
                            </div>
                        )}
                        
                        {/* Imagem Placeholder de Plano */}
                        <div className="relative h-48 bg-gradient-to-br from-[#000033] to-black flex items-center justify-center overflow-hidden">
                            <FiSmartphone size={80} className="text-white/10" />
                            <div className="absolute bottom-0 left-0 w-full p-4 bg-gradient-to-t from-black to-transparent">
                                <span className="text-[9px] font-black text-accent uppercase tracking-widest">{formData.tipoNegocio}</span>
                            </div>
                        </div>

                        {/* Conteúdo do Card */}
                        <div className="p-6 space-y-4">
                            <h3 className="text-lg font-black text-white uppercase leading-tight line-clamp-2">{formData.titulo || 'NOME DO PLANO'}</h3>
                            
                            <div className="space-y-2">
                                {[1, 2, 3, 4].map(i => formData[`beneficio${i}`] && (
                                    <div key={i} className="flex items-center gap-2 text-[10px] text-white/60 font-bold uppercase italic">
                                        <FiCheckCircle size={12} className="text-accent" />
                                        {formData[`beneficio${i}`]}
                                    </div>
                                ))}
                            </div>

                            <div className="pt-4 border-t border-white/5 flex items-end justify-between">
                                <div>
                                    <span className="text-[8px] font-black text-white/40 uppercase block">Mensalidade</span>
                                    <span className="text-2xl font-black text-white leading-none">R$ {formData.valorVenda || '0,00'}</span>
                                </div>
                                <div className="bg-accent h-10 w-10 rounded-xl flex items-center justify-center text-black">
                                    <FiZap size={20} />
                                </div>
                            </div>
                        </div>

                        {/* Badge VIP Overlay */}
                        {formData.isVIP === 'Sim' && (
                            <div className="absolute top-4 right-4 z-20 bg-[#EB0404] text-white p-2 rounded-lg shadow-xl animate-pulse">
                                <FiAward size={16} />
                            </div>
                        )}
                    </div>
                </div>

                {/* 🌐 LADO DIREITO: RESUMO DE DADOS & SEO */}
                <div className="lg:col-span-7 space-y-10">
                    
                    {/* 🕵️ RESUMO DE TARIFAÇÃO */}
                    <div className="space-y-4">
                        <Label icon={FiActivity} text="Resumo da Tarifação" />
                        <div className="grid grid-cols-2 gap-4">
                            <div className="p-4 rounded-2xl bg-white/5 border border-white/5">
                                <span className="text-[8px] font-black text-white/30 uppercase block mb-1">Custo do Chip</span>
                                <span className="text-lg font-black text-white">R$ {formData.valorCondominio || '0,00'}</span>
                            </div>
                            <div className="p-4 rounded-2xl bg-white/5 border border-white/5">
                                <span className="text-[8px] font-black text-white/30 uppercase block mb-1">Fidelidade</span>
                                <span className="text-lg font-black text-white">{formData.valorIptu || 'Não Informada'}</span>
                            </div>
                        </div>
                    </div>

                    {/* 🔍 PREVIEW GOOGLE SEO */}
                    <div className="space-y-4">
                        <Label icon={FiGlobe} text="Radar de Indexação (Google Search)" accent />
                        <div className="p-6 rounded-2xl bg-[#171717] border border-[#303134] font-sans">
                            <div className="flex items-center gap-2 mb-2">
                                <div className="w-5 h-5 rounded-full bg-[#303134] flex items-center justify-center"><FiSearch size={10} className="text-[#8ab4f8]"/></div>
                                <span className="text-[12px] text-[#bdc1c6] truncate opacity-80">https://marketplace.mos.com.br › planos</span>
                            </div>
                            <h3 className="text-[18px] text-[#8ab4f8] hover:underline cursor-pointer font-medium leading-tight mb-1">
                                {displaySeoTitle}
                            </h3>
                            <p className="text-[13px] text-[#bdc1c6] leading-snug line-clamp-2">
                                {displaySeoDesc}
                            </p>
                        </div>
                    </div>

                    {/* 🛡️ FLAGS DE AUTOMAÇÃO (CHECK) */}
                    <div className="space-y-4">
                        <Label icon={FiShield} text="Gatilhos Ativos no Circuito" />
                        <div className="flex flex-wrap gap-3">
                            <Badge status={formData.isVIP === 'Sim'} icon={FiAward} text="Canal VIP" color="#EB0404" />
                            <Badge status={formData.isPortabilidade === 'Sim'} icon={FiRefreshCw} text="Portabilidade" color="#3b82f6" />
                            <Badge status={formData.isClienteTIM_CPF === 'Sim'} icon={FiUser} text="Cliente TIM CPF" color="#10b981" />
                        </div>
                    </div>
                </div>
            </div>

            {/* 🛡️ FOOTER FINAL */}
            <div className="mt-10 p-10 rounded-[40px] border border-dashed border-white/10 bg-white/[0.02] flex flex-col items-center justify-center text-center space-y-4">
                <FiShield size={40} className="text-accent opacity-20" />
                <div>
                    <h4 className="text-sm font-black uppercase tracking-widest text-white/80">Protocolo de Integridade Finalizado</h4>
                    <p className="text-[9px] font-bold uppercase opacity-30 mt-1 max-w-md mx-auto">
                        Ao prosseguir, os dados serão injetados no banco de dados e sincronizados com a Ponte de Vendas TIM UNITY.
                    </p>
                </div>
            </div>
        </div>
    );
}

// 💎 SUB-COMPONENTE: LABEL INDUSTRIAL
const Label = ({ icon: Icon, text, accent }) => (
    <div className="flex items-center gap-3 mb-4">
        <div className={`w-8 h-8 rounded-lg border flex items-center justify-center ${accent ? 'border-accent text-accent bg-accent/5 shadow-[0_0_15px_rgba(var(--accent-rgb),0.1)]' : 'border-white/10 opacity-30'}`}>
            <Icon size={16} />
        </div>
        <h3 className="text-[10px] font-black uppercase tracking-widest opacity-70">{text}</h3>
    </div>
);

// 🏷️ SUB-COMPONENTE: BADGE STATUS
const Badge = ({ status, icon: Icon, text, color }) => (
    <div className={`flex items-center gap-2 px-4 py-2 rounded-xl border transition-all ${status ? 'border-opacity-100 text-white' : 'opacity-20 border-white/5 grayscale'}`}
         style={{ borderColor: status ? color : 'rgba(255,255,255,0.05)', backgroundColor: status ? `${color}15` : 'transparent' }}>
        <Icon size={14} style={{ color: status ? color : 'inherit' }} />
        <span className="text-[9px] font-black uppercase tracking-widest">{text}</span>
    </div>
);